import api from './api-caller';
const baseEndpoint = '/organizations'
import utils from '../mixins/utils';
const { getOrganizationPublicId } = utils.methods;


export default {
  retrieveEmbed: (embedCode) => {
    let endpoint = `/embed/${embedCode}`;
    return api(endpoint, 'GET');
  },
  createEmbed: (obj) => {
    const endpoint = `${baseEndpoint}/${getOrganizationPublicId()}/embed`;
    return api(endpoint, 'POST', obj);
  }
}
